/**
 * 调度器
 */
const queue: Function[] = [];
let isFlushing = false;
const resolvedPromise = Promise.resolve();
let currentFlushPromise: Promise<void>;

export function nextTick(fn: Function = () => {}) {
  const p = currentFlushPromise || resolvedPromise;
  return fn ? p.then(fn()) : p;
}

export function queueJob(job: Function) {
  if (!queue.length || !queue.includes(job)) {
    queue.push(job);
    queueFlush();
  }
}

function queueFlush() {
  if (!isFlushing) {
    isFlushing = true;
    currentFlushPromise = resolvedPromise.then(flushJobs);
  }
}

function flushJobs() {
  try {
    for (let i = 0; i < queue.length; i++) {
      const job = queue[i];
      job();
    }
  } finally {
    isFlushing = false;
    queue.length = 0;
    currentFlushPromise = Promise.resolve();
  }
}
